module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAMCAYAAABr5z2BAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADCSURBVHgBjVEBDcIwEPxNwRxQFDAUMAlzwByAAyqhKJgUkICDggLmoFyTa9Y1Ldsll+/ft9/Pn0gBzrkGVInWgzbW68LjM4IFh6T0Yhzlz883N0NTu4ADzx1rfW7k0S0RGmjmirkFHxIlJeio+Rc0zI3Pww6UrKCqqgnhDR6iXfimu1q2Y8qJdamQQcspwtlP9vEN9uRRZpsWwKhXhAa8UzqBTylcNpkldmwS2zhICZFtOtEbumZlDfxJJVpLO7ug/QBFzedsbnbL7QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/audio/btn_player_volume.png
// module id = 3v6H
// module chunks = 1